class FabricSwatches extends HTMLElement {
  constructor() {
    super();
    this.body = document.querySelector('body');
    this.swatches = this.querySelector('.fabric-swatches__swatches');
    this.close = this.querySelector('.fabric-swatches__close');
    this.selectButtons = this.querySelectorAll('.js-select-fabric');
    this.currentSide = '';
    this.addEventListeners();
    this.classList.remove('hidden');
  }

  addEventListeners() {
    this.close.addEventListener('click', () => this.closeModal());
    this.addEventListener('click', (event) => {
      if (!event.target.closest('.fabric-swatches__inner')) {
        this.closeModal();
      }
    });
    this.selectButtons.forEach(button => {
      button.addEventListener('click', () => this.getSelectedFabric());
    });
  }

  openModal(side) {
    this.currentSide = side;
    const swatchFront = this.querySelector('.fabric-swatches__swatches--front');
    const swatchBack = this.querySelector('.fabric-swatches__swatches--back');

    if (side == 'front') {
      if (swatchFront) {
        swatchFront.classList.add('active');
      }
      if (swatchBack) {
        swatchBack.classList.remove('active');
      }
    } else {
      if (swatchFront) {
        swatchFront.classList.remove('active');
      }
      if (swatchBack) {
        swatchBack.classList.add('active');
      }
    }

    this.updatePrice();

    this.classList.add('fabric-swatches--active');
    this.swatches.classList.add('is-active');

    this.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.classList.remove('fabric-swatches--active');
    this.swatches.classList.remove('is-active');
    this.body.style.overflow = 'auto';
  }

  updatePrice() {
    const priceToUpdate = this.querySelector('.js-price');
    const price = document.querySelector('.product__information .price').getAttribute('data-price-with-currency');
    priceToUpdate.innerText = price;
  }

  getSelectedFabric() {
    const activeFabric = this.querySelector('.fabric-swatches__swatch.selected');
    const newFabric = activeFabric.dataset.value;
    const newImage = activeFabric.dataset.img;

    const trigger = document.querySelector(`fabric-trigger[data-side="${this.currentSide}"]`);
    trigger.updateSelectedFabric(newFabric, newImage);

    this.closeModal();
  }

}

customElements.define('fabric-swatches', FabricSwatches);

class FabricTrigger extends HTMLElement {
  constructor() {
    super();
    this.modal = document.querySelector('fabric-swatches');
    this.input = this.querySelector('input');
    this.name = this.querySelector('.product-fabric-data__name');
    this.image = this.querySelector('img');
    this.placeholder = this.querySelector('.product-fabric-data__placeholder');
    this.subtitles = this.querySelectorAll('.product-fabric-data__subtitle');
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener('click', () => this.modal.openModal(this.dataset.side));
  }

  updateSelectedFabric(fabric, image) {
    this.input.setAttribute('value', fabric);
    this.updateBespokeForm(fabric);
    this.subtitles.forEach(subtitle => {
      subtitle.classList.add('hidden');
    });
    this.name.innerHTML = fabric;
    this.placeholder.classList.add('hidden');
    this.image.src = image;
    this.image.classList.remove('hidden');
  }

  updateBespokeForm(fabric) {

    let bespokeHiddenField = null;

    if (this.input.id.startsWith('front')) {
      bespokeHiddenField = document.getElementById('bespoke-form-front-fabric');
    } else if (this.input.id.startsWith('back')) {
      bespokeHiddenField = document.getElementById('bespoke-form-back-fabric');
    }

    if (!bespokeHiddenField) return;


    // replace the value of the hidden field with the fabric
    bespokeHiddenField.style = "display: block; width: 100%; outline:2px solid green;";
    bespokeHiddenField.value = fabric;
  }

}

customElements.define('fabric-trigger', FabricTrigger);

class FabricSwatch extends HTMLElement {
  constructor() {
    super();
    this.allSwatches = document.querySelectorAll('fabric-swatch');
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener('click', (event) => {
      this.removeSelected();
      this.addCurrentlySelected(event);
    });
  }

  removeSelected() {
    this.allSwatches.forEach(swatch => {
      swatch.classList.remove('selected');
    });
  }

  addCurrentlySelected(event) {
    this.classList.add('selected');
  }

}

customElements.define('fabric-swatch', FabricSwatch);